import * as moment from 'moment';

export function formatSelectedDay(date: Date): string {
  return moment(date).format('YYYY-MM-DDTHH:mm:ss');
}
